var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02ImagesImgLogoXcape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.316,
    height: 46,
    viewBox: "0 0 59.316 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fkt78vxtba",
    d: "M0.008 0.051L17.804 0.051 17.804 15.729 0.008 15.729z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.342)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g12q3fxwmb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fkt78vxtba"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.804.051L15.689.051 9.215 6.546 10.28 7.61 17.804.051M4.797 3.139L4.806 3.13 2.115.43 0 .43 7.639 8.072 0 15.737 2.115 15.737 8.68 9.151 15.246 15.737 17.361 15.737 12.106 10.442 4.797 3.139",
    mask: "url(#g12q3fxwmb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.12 10.84c.088.078.066.178-.011.233-.707.6-1.568 1.043-2.584 1.043-2.175 0-3.865-1.775-3.865-3.995 0-2.23 1.69-4.005 3.865-4.005 1.016 0 1.877.443 2.584 1.031.077.067.1.156.011.233l-.232.234c-.088.077-.154.066-.232 0-.596-.5-1.28-.822-2.12-.822-1.745 0-3.18 1.42-3.18 3.33 0 1.897 1.435 3.317 3.18 3.317.84 0 1.524-.321 2.12-.82.078-.067.144-.078.232 0l.232.221M33.134 9.442l-1.59-4.428-1.601 4.428h3.191zm1.402 2.53h-.353c-.088 0-.154-.033-.188-.133l-.662-1.831h-3.589l-.662 1.831c-.033.1-.1.133-.188.133h-.353c-.122 0-.177-.078-.133-.189l2.728-7.446c.033-.088.11-.133.198-.133h.409c.088 0 .166.045.199.133l2.727 7.446c.044.111-.011.19-.133.19zM44.374 6.579c0-1.232-.828-1.72-1.9-1.72h-1.446v3.44h1.447c1.07 0 1.899-.488 1.899-1.72zm.674 0c0 1.343-.884 2.375-2.53 2.375h-1.49v2.852c0 .1-.066.166-.165.166h-.365c-.1 0-.165-.067-.165-.166V4.37c0-.1.066-.167.165-.167h2.02c1.646 0 2.53 1.021 2.53 2.375zM54.885 11.484v.322c0 .1-.066.166-.166.166h-3.743c-.1 0-.166-.067-.166-.166V4.37c0-.1.067-.167.166-.167h3.732c.1 0 .166.067.166.167v.322c0 .1-.066.166-.166.166h-3.202V7.5h3.015c.099 0 .165.067.165.167v.321c0 .1-.066.167-.165.167h-3.015v3.162h3.213c.1 0 .166.067.166.167M56.136 11.972L56.136 11.192 55.846 11.192 55.846 11.087 56.544 11.087 56.544 11.192 56.253 11.192 56.253 11.972 56.136 11.972M56.66 11.972v-.885h.175l.209.627.042.13.046-.141.211-.616h.157v.885h-.112v-.74l-.256.74h-.105l-.255-.753v.753h-.112",
    transform: "translate(0 16.342)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02ImagesImgLogoXcape);
export default __webpack_public_path__ + "static/media/02-images-img-logo-xcape.b799835d1694b8ce8d346a973ab8d0ca.svg";
export { ForwardRef as ReactComponent };